module.exports = __webpack_public_path__ + "static/media/img1-tc-desktop.463f673e.png";